import s from './CenteredImages.module.scss'
import LazyImage from '@/components/Common/LazyImage'
import LazyVideo from '@/components/Common/LazyVideo'

type Props = { data: any; priority?: boolean }

export default function CenteredImages({ data, priority = false }: Props) {
  return (
    <div className={`${s.centeredImages} ${data.images.length > 2 ? s.threeColumns : ''}`}>
      {data?.images?.map((image: any, index: number) => (
        <div key={`centered-image-${index}`} className={`${s.imageWrapper} ${s[`imageCount${data.images.length}`]}`}>
          {image._type === 'image' ? (
            <LazyImage
              src={image?.imageUrl}
              alt={image?.alt}
              width={image?.metadata.dimensions.width || 800}
              height={image?.metadata.dimensions.height || 600}
              filename={image.filename}
              priority={priority && index === 0}
            />
          ) : (
            <div>
              <LazyVideo
                thumbnail={image?.image}
                src={image?.videoUrl}
                autoplay={true}
                muted={true}
                allowAudio={image?.allowAudio}
                fullHeight={data.images.length < 3}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
